var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEuroClass = function SvgIconEuroClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5341 20L12.0887 15.9466L6.40679 19.9726L8.61096 13.5834L3 9.46352L9.80175 9.56916L12.0138 3L14.0208 9.45179L21 9.51047L15.4324 13.3956L17.5341 20Z",
    fill: "#05072C"
  })));
};
export default SvgIconEuroClass;